/**
 * Deterministic warm-palette avatar colors. We don't have employee photos,
 * so we render initials in a colored circle · the color is derived from
 * the email so each person keeps the same hue across the app.
 */
const PALETTE = [
  { bg: '#e6d3c2', fg: '#5a3a22' }, // warm sand
  { bg: '#dec9bd', fg: '#5a3526' },
  { bg: '#cdd6c4', fg: '#34472b' }, // olive
  { bg: '#c8d3d7', fg: '#2c4651' }, // slate
  { bg: '#e3cdc7', fg: '#5b2a26' }, // terracotta
  { bg: '#d6c9da', fg: '#42305a' }, // mauve
  { bg: '#e5dab0', fg: '#5b4b1a' }, // ochre
  { bg: '#bfd2c4', fg: '#1f4533' }, // forest
];

const hash = (s) => {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
};

export function avatarFor(key = '') {
  const k = String(key).toLowerCase();
  return PALETTE[hash(k) % PALETTE.length];
}

export function initialsFor(fullName = '', email = '') {
  const name = (fullName || email.split('@')[0] || '?').trim();
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
